import { DeclarationDrBase } from './declaration-dr.base.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class DeclarationDpCave extends DeclarationDrBase {
    static jsonMap = {
        ...DeclarationDrBase.jsonMap,
        s_recolte: { key: 's_recolte' },
        vol_app_r: { key: 'vol_app_r' },
        vol_issu_r: { key: 'vol_issu_r' },
        vol_app_m: { key: 'vol_app_m' },
        vol_issu_m: { key: 'vol_issu_m' },
        vol_a_elim: { key: 'vol_a_elim', optional: true },
        vol_vsi: { key: 'vol_vsi' },
        vol_vci: { key: 'vol_vci' },
        apport: { key: 'cvi_apporteur', optional: true, default: '' },
        details: { key: 'list', converter: new (ArrayClassConverterFactory.build(DeclarationDpCave))(), optional: true, default: () => [] }
    };

    s_recolte: number;
    vol_app_r: number;
    vol_issu_r: number;
    vol_app_m: number;
    vol_issu_m: number;
    vol_a_elim: number;
    vol_vsi: number;
    vol_vci: number;
    apport: string;
    details: DeclarationDpCave[];
}
